// extracted by mini-css-extract-plugin
module.exports = {"modal_content":"RemoveConsumptionModal_modal_content__i3yvx","modal_header":"RemoveConsumptionModal_modal_header__1KofP","modal_body":"RemoveConsumptionModal_modal_body__iN1ut"};